import { render } from "./equipDialog.vue?vue&type=template&id=6129f841&scoped=true&ts=true"
import script from "./equipDialog.vue?vue&type=script&lang=ts"
export * from "./equipDialog.vue?vue&type=script&lang=ts"

import "./equipDialog.vue?vue&type=style&index=0&id=6129f841&lang=scss&scoped=true"

import exportComponent from "/Users/star/Desktop/clz-frontend/taxi-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6129f841"]])

export default __exports__